import type { CSSProperties } from 'react';
import type { Fund } from '../types/server-data/ClientConfig';
import { tailwindColors } from '../../tailwind.config';

/** Fund ids flagged as demo via get_funds (`is_demo_fund` → `isDemoFund`). */
export function buildDemoFundIdSet(
  funds: Array<Pick<Fund, 'id' | 'isDemoFund'>> | null | undefined,
): Set<string> {
  return new Set(
    (funds ?? []).filter((fund) => fund.isDemoFund).map((fund) => fund.id),
  );
}

/** Row background for demo funds in tables (matches the fund picker tint). */
export const DEMO_ROW_BACKGROUND = tailwindColors.demo_bg;

/**
 * material-table / CustomTable `rowStyle` that tints demo fund rows.
 * Pass any existing static row style as `baseStyle`; it is kept for all rows.
 */
export function demoRowStyle<T extends { isDemoFund?: boolean }>(
  baseStyle: CSSProperties = {},
) {
  return (rowData: T): CSSProperties =>
    rowData.isDemoFund
      ? { ...baseStyle, backgroundColor: DEMO_ROW_BACKGROUND }
      : baseStyle;
}
